import React from 'react';
import { AlertCircle, Info } from 'lucide-react';

export const DemoBanner = () => {
  return (
    <div className="bg-amber-50 border-l-4 border-amber-500 p-4 mb-6">
      <div className="flex items-start gap-3">
        <Info className="h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5" />
        <div>
          <h3 className="text-sm font-semibold text-amber-900 mb-1">
            Demo Mode - Smart Contracts Not Deployed
          </h3>
          <p className="text-sm text-amber-800">
            This is a UI demonstration with mock data. To enable full functionality (minting and financing), 
            deploy the smart contracts to Sepolia testnet and update the contract addresses in the .env files. 
            See <span className="font-mono bg-amber-100 px-1 rounded">/app/contracts/README.md</span> for deployment instructions.
          </p>
        </div>
      </div>
    </div>
  );
};
